import { render } from "./YoutubeVideoplayer.vue?vue&type=template&id=7abddb5e&scoped=true"
import script from "./YoutubeVideoplayer.vue?vue&type=script&lang=js"
export * from "./YoutubeVideoplayer.vue?vue&type=script&lang=js"

import "./YoutubeVideoplayer.vue?vue&type=style&index=0&id=7abddb5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abddb5e"]])

export default __exports__